"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileAppsResponseToJSON = exports.MobileAppsResponseFromJSONTyped = exports.MobileAppsResponseFromJSON = exports.instanceOfMobileAppsResponse = void 0;
var runtime_1 = require("../runtime");
var MobileApp_1 = require("./MobileApp");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the MobileAppsResponse interface.
 */
function instanceOfMobileAppsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfMobileAppsResponse = instanceOfMobileAppsResponse;
function MobileAppsResponseFromJSON(json) {
    return MobileAppsResponseFromJSONTyped(json, false);
}
exports.MobileAppsResponseFromJSON = MobileAppsResponseFromJSON;
function MobileAppsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'mobileApps': !(0, runtime_1.exists)(json, 'mobile_apps') ? undefined : (json['mobile_apps'].map(MobileApp_1.MobileAppFromJSON)),
    };
}
exports.MobileAppsResponseFromJSONTyped = MobileAppsResponseFromJSONTyped;
function MobileAppsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'mobile_apps': value.mobileApps === undefined ? undefined : (value.mobileApps.map(MobileApp_1.MobileAppToJSON)),
    };
}
exports.MobileAppsResponseToJSON = MobileAppsResponseToJSON;
